import React from 'react';
import { IconProps } from '../IconProps';

const SvgMoodFacePlus = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
    <g clipPath="url(#MoodFacePlus_svg__clip0_446_3217)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.636.002a9.997 9.997 0 0 0-4.92 1.502A10.015 10.015 0 0 0 .512 6.828a9.807 9.807 0 0 0-.508 3.17c0 .475.012.711.057 1.116a9.985 9.985 0 0 0 4.06 6.976c.806.589 1.74 1.07 2.707 1.394a9.797 9.797 0 0 0 3.172.51 8.7 8.7 0 0 0 1.116-.057 9.987 9.987 0 0 0 6.817-3.848c.667-.863 1.2-1.865 1.554-2.92a9.842 9.842 0 0 0 .505-2.786c0-.049.003-.081.008-.081.006 0 .008-.11.008-.314 0-.206-.003-.31-.008-.302-.005.008-.008-.015-.008-.072a9.988 9.988 0 0 0-4.112-7.708A10.071 10.071 0 0 0 13.172.51 9.83 9.83 0 0 0 10.65.017c-.16-.011-.87-.022-1.013-.015zM9.56 1.438a8.486 8.486 0 0 0-3.384.889 8.393 8.393 0 0 0-1.832 1.231c-.249.218-.674.652-.9.92a8.559 8.559 0 0 0-1.96 4.54c-.07.629-.07 1.33 0 1.96a8.557 8.557 0 0 0 2.964 5.548 8.534 8.534 0 0 0 6.28 2.011 8.448 8.448 0 0 0 3.132-.887 8.22 8.22 0 0 0 1.718-1.146c.316-.271.676-.632.95-.955a8.496 8.496 0 0 0 1.524-2.611 8.587 8.587 0 0 0-.826-7.552 8.325 8.325 0 0 0-.718-.965 9.237 9.237 0 0 0-.956-.952 8.519 8.519 0 0 0-5.135-2.031c-.185-.01-.67-.01-.857 0zm-2.797 4.92c-.357.037-.66.233-.837.54A1.072 1.072 0 0 0 7.04 8.483a1.073 1.073 0 0 0-.277-2.125zm6.281 0a1.075 1.075 0 0 0-.972 1.068 1.074 1.074 0 0 0 1.232 1.06 1.08 1.08 0 0 0 .905-.962 1.072 1.072 0 0 0-.979-1.166.643.643 0 0 0-.186 0zM.004 9.998c0 .173.001.244.002.158.002-.087.002-.23 0-.316-.001-.087-.002-.016-.002.158zm5.16.724a.699.699 0 0 0-.52.391.594.594 0 0 0-.07.309c0 .097.002.117.025.204.346 1.268 1.213 2.422 2.385 3.173a5.91 5.91 0 0 0 2.736.928c.156.014.718.014.868 0 .456-.043.892-.128 1.156-.227a6.368 6.368 0 0 0 1.68-.954c.323-.256.646-.573.9-.88a5.547 5.547 0 0 0 1.078-2.042.586.586 0 0 0 .025-.203.59.59 0 0 0-.07-.307.699.699 0 0 0-.528-.392.664.664 0 0 0-.433.066.646.646 0 0 0-.183.129c-.102.098-.148.184-.209.389-.304 1.027-1.05 1.94-2.068 2.526a5.227 5.227 0 0 1-.684.324 3.64 3.64 0 0 1-.668.134 5.626 5.626 0 0 1-.707.012 4.45 4.45 0 0 1-1.949-.602 4.333 4.333 0 0 1-1.513-1.462 3.912 3.912 0 0 1-.423-.948c-.057-.19-.107-.28-.209-.377a.707.707 0 0 0-.619-.19z"
        fill={primaryColor}
      />
      <circle cx={16.175} cy={3.824} r={3.824} fill={secondaryColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.168 1.172c.276 0 .5.083.5.185V6.28c0 .102-.224.185-.5.185s-.5-.083-.5-.185V1.357c0-.102.224-.185.5-.185z"
        fill={primaryColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.668 3.822c0-.276.078-.5.174-.5h4.652c.096 0 .174.224.174.5s-.078.5-.174.5h-4.652c-.096 0-.174-.224-.174-.5z"
        fill={primaryColor}
      />
    </g>
    <defs>
      <clipPath id="MoodFacePlus_svg__clip0_446_3217">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMoodFacePlus;
